/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';
import { ButtonWithIcon } from '@els/els-react--button';
import { StructureOptionsBadges } from '@Containers/StructureOptions';
import { QUICK_SEARCH_STRUCTURE_UID } from '../../../QuickSearchConstants';

import './BuildQueryStructureDrawing.scss';

function BuildQueryStructureDrawing(props) {
  const { structurePreview, clearStructure, previewSize, goToStructure, structureName } = props;
  const drawButtonRef = useRef(null);
  const handleClear = (e) => {
    e.stopPropagation();
    clearStructure();
    setTimeout(() => {
      drawButtonRef.current?.focus();
    }, 0);
  };
  return (
    <div className="build-query-structure-drawing">
      <p>AND</p>
      {!structurePreview && (
        <LinkElement
          href="#"
          iconSprite="DrawStructureNew"
          ref={drawButtonRef}
          onClick={(e) => {
            e.preventDefault();
            goToStructure();
          }}
          data-e2e="e2e-build-query-structuredrawing-draw"
          className=" build-query-structure-drawing__draw-button e2e-build-query-structuredrawing-draw"
          aria-label="Draw quick search structure">
          Draw Structure / Reaction
        </LinkElement>
      )}
      {structurePreview && (
        <div>
          <div
            className="build-query-structure-drawing__structure"
            aria-label="drawn chemical structure, press enter to edit structure"
            onClick={() => goToStructure()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                goToStructure();
              }
            }}>
            <ButtonWithIcon
              type="link"
              size="small"
              iconOnly
              sprite="Close"
              data-e2e="e2e-build-query-structureDrawing-clear-button"
              linkIconSize="s"
              iconRight
              tabIndex="0"
              onClick={handleClear}
              onKeyDown={(e) => e.stopPropagation()}
              className="build-query-structure-drawing__structure_clearButton"
              aria-label="Clear quick search structure">
              Clear quick search structure
            </ButtonWithIcon>
            <img
              className="build-query-structure-drawing__structure_image"
              width={`${previewSize ? previewSize.width : 200}px`}
              src={structurePreview}
              data-e2e="e2e-build-query-structure-drawing-image"
              alt={(() => {
                if (!structureName) {
                  return 'Preview of drawn structure';
                }
                const structureType = structureName.isLinearFormula ? 'linear formula' : 'chemical structure';
                const structureValue = structureName.isLinearFormula ? structureName.name : structureName.name || structureName;
                return structureValue ? `Preview of ${structureType}: ${structureValue}` : `Preview of ${structureType}`;
              })()}
            />
            <div className="build-query-structure-drawing__structure_editButton e2e-build-query-structure-drawing-edit">
              <StructureOptionsBadges id={QUICK_SEARCH_STRUCTURE_UID} onStructureOptionClick={goToStructure} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

BuildQueryStructureDrawing.propTypes = {
  structurePreview: PropTypes.string,
  clearStructure: PropTypes.func.isRequired,
  previewSize: PropTypes.object,
  goToStructure: PropTypes.func.isRequired,
  structureName: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, isLinearFormula: PropTypes.bool })]),
};

export default BuildQueryStructureDrawing;
